<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Temporary User Management Page
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Temporary User",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      adminlist: [],
      adminsearch: "",
      userinfo: null,
      loading: true,
      block: false,
      systemtype: 0,
      checkoutloading: {},
      deleteLoading: {},
      resetLoading: {},
      removeLoading: {},
      // 分页相关
      pagesize: 10,
      currentPage: 1,
    };
  },
  mounted() {
    this.title = this.$t("admin.temporary.text");
    this.items = [
      {
        text: this.$t("menuitems.user.text"),
        href: "/user/list",
      },
      {
        text: this.$t("admin.temporary.text"),
        active: true,
      },
    ];

    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
      {
        const rid = parseInt(
          this.userinfo.roleid != null
            ? this.userinfo.roleid
            : this.userinfo.roleId,
          10
        );
        if (Number.isFinite(rid) ? rid !== 0 : parseInt(this.userinfo.topuid, 10) >= 1) {
          this.block = true;
        }
      }
    } catch (error) {
      console.error("解析用户信息失败:", error);
      this.$message.error(this.$t("global.error.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }

    this.getsysteminfo();
    this.getadminlist();
    
    if (this.$route.query.hex) {
      this.adminsearch = this.$route.query.hex;
    }
  },
  methods: {
    getsysteminfo() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.systemtype = parseInt(response.data.data.model);
        })
        .catch((error) => {
          console.error("获取系统信息失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    getadminlist() {
      this.loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "gettempuser",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.loading = false;
          if (response.data.status === 200) {
            this.adminlist = response.data.data || [];
          } else {
            this.$message.error(response.data.message || this.$t("global.errors.loaddata"));
            this.adminlist = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取临时用户列表失败:", error);
          this.$message.error(this.$t("global.errors.network"));
          this.adminlist = [];
        });
    },
    deleteadmin(id) {
      this.$confirm(
        this.$t("global.delete.deletetempusertip"),
        this.$t("global.delete.sureyouaction"),
        {
          confirmButtonText: this.$t("global.button.ok"),
          cancelButtonText: this.$t("global.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$set(this.deleteLoading, id, true);
          this.$axios
            .post(
              this.apiuri,
              {
                action: "checkout",
                hex: id,
                status: 0,
              },
              {
                headers: { Openid: this.userinfo.openid },
              }
            )
            .then((response) => {
              this.$set(this.deleteLoading, id, false);
              if (response.data.status === 200) {
                this.$message({
                  message: this.$t("global.success"),
                  type: "success",
                });
                this.getadminlist();
              } else if (response.data.status === 403) {
                this.$message({
                  message: this.$t("admin.temporary.delete403"),
                  type: "warning",
                });
              } else {
                this.$message.error(response.data.message || this.$t("global.delete.500"));
              }
            })
            .catch((error) => {
              this.$set(this.deleteLoading, id, false);
              console.error("删除临时用户失败:", error);
              this.$message.error(this.$t("global.errors.network"));
            });
        })
        .catch(() => {});
    },
    removefromgroup(uid, idx) {
      const loadingKey = `${uid}_${idx}`;
      this.$set(this.removeLoading, loadingKey, true);
      this.$axios
        .post(
          this.apiuri,
          {
            action: "rmusergroup",
            uid: uid,
            group: idx,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.$set(this.removeLoading, loadingKey, false);
          if (response.data.status === 200) {
            this.$message({
              message: this.$t("global.success"),
              type: "success",
            });
            this.getadminlist();
          } else {
            this.$message.error(response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          this.$set(this.removeLoading, loadingKey, false);
          console.error("从组中移除用户失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    checkout(uid, idx, status) {
      this.$confirm(
        this.getCheckoutConfirmTip(status),
        this.$t("global.waring"),
        {
          confirmButtonText: this.$t("device.button.checkout"),
          cancelButtonText: this.$t("device.button.notcheckout"),
          type: "warning",
        }
      )
        .then(() => {
          const loadingKey = `${uid}_${idx}_${status}`;
          this.$set(this.checkoutloading, loadingKey, true);
          this.$axios
            .post(
              this.apiuri,
              {
                action: "checkout",
                hex: uid,
                group: idx,
                status: status,
              },
              {
                headers: { Openid: this.userinfo.openid },
              }
            )
            .then((response) => {
              this.$set(this.checkoutloading, loadingKey, false);
              if (response.data.status === 200) {
                this.$message({
                  message: this.$t("global.success"),
                  type: "success",
                });
                this.getadminlist();
              } else {
                this.$message.error(response.data.message || this.$t("global.errors.operation"));
              }
            })
            .catch((error) => {
              this.$set(this.checkoutloading, loadingKey, false);
              console.error("结账操作失败:", error);
              this.$message.error(this.$t("global.errors.network"));
            });
        })
        .catch(() => {});
    },
    getCheckoutConfirmTip(status) {
      return status === 1
        ? this.$t("user.temporary.checkouttip_keep")
        : this.$t("user.temporary.checkouttip_normal");
    },
    resetdrinkfreetime(hex) {
      this.$set(this.resetLoading, hex, true);
      this.$axios
        .post(
          this.apiuri,
          {
            action: "reset_drink_free_time",
            hex
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.$set(this.resetLoading, hex, false);
          if (response.data.status === 200) {
            this.$message({
              message: this.$t("global.success"),
              type: "success",
            });
            this.getadminlist();
          } else {
            this.$message.error(response.data.message || this.$t("global.delete.500"));
          }
        })
        .catch((error) => {
          this.$set(this.resetLoading, hex, false);
          console.error("重置畅饮时间失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    openOrderDetail(row) {
      this.$router.push({
        path: "/user/temporary-orders",
        query: {
          hex: row.hex,
          username: row.remark || "",
        },
      });
    },
    formatDrinkFreeTimeRange(row) {
      if (!row || !row.begin || !row.end) {
        return "-";
      }
      return `${row.begin} 至 ${row.end}`;
    },
    formatDrinkOtherSettings(row) {
      if (!row || row.drinkfreely !== 1) {
        return "-";
      }
      const checkDeviceText = String(row.drink_check_device) === "1" ? "是" : "否";
      const details = [
        `单杯:${row.drink_price || "-"}`,
        `结账:${row.drink_maxprice || "-"}`,
        `最大打酒量:${row.drink_maxvalue || "-"}`,
        `锁定设备:${checkDeviceText}`,
        `设备:${row.drink_device || "-"}`,
      ];
      return details.join("\n");
    },
    handleActionCommand(command, row) {
      if (command === "reset") {
        this.resetdrinkfreetime(row.hex);
      } else if (command === "detail") {
        this.openOrderDetail(row);
      } else if (command === "checkout0") {
        this.checkout(row.hex, row.group, 0);
      } else if (command === "checkout1") {
        this.checkout(row.hex, row.group, 1);
      } else if (command === "remove") {
        this.removefromgroup(row.id, row.group);
      } else if (command === "delete") {
        this.deleteadmin(row.hex);
      }
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    refresh() {
      this.getadminlist();
    },
    /**
     * 格式化消费量（处理千位分隔符）
     * @param {string|number} value 消费量值
     * @returns {string} 格式化后的数值
     */
    formatConsumptionValue(value) {
      if (value === undefined || value === null || value === '') {
        return '0';
      }
      // 如果是字符串，移除千位分隔符（逗号）
      if (typeof value === 'string') {
        value = value.replace(/,/g, '');
      }
      // 转换为数字并格式化（移除小数部分，如果有的话）
      const numValue = parseFloat(value) || 0;
      return Math.floor(numValue).toLocaleString('en-US');
    },
    /**
     * 格式化金额（处理千位分隔符）
     * @param {string|number} value 金额值
     * @returns {string} 格式化后的金额（保留2位小数，带千位分隔符）
     */
    formatAmount(value) {
      if (value === undefined || value === null || value === '') {
        return '0.00';
      }
      // 如果是字符串，移除千位分隔符（逗号）
      if (typeof value === 'string') {
        value = value.replace(/,/g, '');
      }
      // 转换为数字并格式化（保留2位小数，带千位分隔符）
      const numValue = parseFloat(value) || 0;
      return numValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  computed: {
    searchinadminlist() {
      if (!this.adminsearch) {
        return this.adminlist;
      }
      const searchTerm = this.adminsearch.trim().toLowerCase();
      return this.adminlist.filter((item) => {
        const remark = (item.remark || "").toLowerCase();
        const hex = (item.hex || "").toLowerCase();
        return remark.includes(searchTerm) || hex.includes(searchTerm);
      });
    },
    showTable() {
      const start = (this.currentPage - 1) * this.pagesize;
      const end = start + this.pagesize;
      return this.searchinadminlist.slice(start, end);
    },
    totalCount() {
      return this.searchinadminlist.length;
    },
  },
  filters: {
    formatTimer: function (value) {
      value = value * 1000;
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading" v-if="!block">
            <!-- 搜索和操作栏 -->
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="input-group">
                  <input 
                    type="search" 
                    v-model="adminsearch" 
                    class="form-control" 
                    :placeholder="$t('user.list.search')"
                    @keyup.enter="adminsearch = adminsearch"
                  />
                  <div class="input-group-append">
                    <el-button 
                      icon="el-icon-refresh" 
                      @click="refresh"
                      :loading="loading"
                      circle
                    ></el-button>
                  </div>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <span class="text-muted">
                  {{ $t('global.text.total') }}: <strong>{{ totalCount }}</strong>
                </span>
              </div>
            </div>

            <!-- 数据表格 -->
            <div class="row">
              <div class="col-12">
                <el-table 
                  :data="showTable" 
                  style="width: 100%"
                  stripe
                  border
                  size="mini"
                  :empty-text="$t('global.text.nodata')"
                >
                  <el-table-column 
                    prop="remark" 
                    :label="$t('admin.lists.username')" 
                    min-width="100"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column 
                    prop="phone" 
                    :label="$t('admin.lists.phone')" 
                    min-width="130"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.phone">{{ scope.row.phone }}</span>
                      <span v-else class="text-muted">{{ $t("admin.lists.nophone") }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    :label="$t('user.temporary.active')" 
                    min-width="165"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.time">
                        {{ scope.row.time | formatTimer }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    prop="hex" 
                    :label="$t('user.list.membercardhex')" 
                    min-width="120"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column 
                    prop="amount" 
                    :label="$t('user.temporary.consumption')" 
                    min-width="110"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.amount !== undefined && scope.row.amount !== null">
                        {{ formatAmount(scope.row.amount) }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    prop="total" 
                    :label="$t('user.temporary.consumptionvalue')" 
                    min-width="110"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.total !== undefined && scope.row.total !== null">
                        {{ formatConsumptionValue(scope.row.total) }} ML
                      </span>
                      <span v-else class="text-muted">0 ML</span>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    prop="drinkfreely" 
                    :label="$t('marketing.wristband.drink')" 
                    width="90"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag 
                        :type="scope.row.drinkfreely == 1 ? 'success' : 'info'" 
                        size="mini"
                      >
                        {{ scope.row.drinkfreely == 1 ? $t('global.text.yes') : $t('global.text.no') }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="时间限制" min-width="230">
                    <template slot-scope="scope">
                      {{ formatDrinkFreeTimeRange(scope.row) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="其它设置" min-width="260">
                    <template slot-scope="scope">
                      <div class="drink-settings-cell">{{ formatDrinkOtherSettings(scope.row) }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column 
                    :label="$t('device.lists.action')" 
                    width="120"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-dropdown trigger="click" @command="(cmd) => handleActionCommand(cmd, scope.row)">
                        <el-button type="primary" size="mini">
                          {{ $t("device.lists.action") }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="reset" v-if="scope.row.drinkfreely == 1">
                            {{ $t("device.button.reset_drinkfreetime") }}
                          </el-dropdown-item>
                          <el-dropdown-item command="detail">消费明细</el-dropdown-item>
                          <el-dropdown-item command="checkout0">{{ $t("device.button.checkout") }}</el-dropdown-item>
                          <el-dropdown-item command="checkout1">{{ $t("device.button.checkout") }}(保留分组)</el-dropdown-item>
                          <el-dropdown-item command="remove" v-if="scope.row.group > 0">{{ $t("user.group.remove") }}</el-dropdown-item>
                          <el-dropdown-item command="delete" divided>{{ $t("device.lists.delete") }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <!-- 分页 -->
            <div class="row mt-3" v-if="totalCount > 0">
              <div class="col-12">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalCount"
                  class="text-right"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="card-body" v-else>
            <el-result 
              icon="error" 
              :title="$t('global.error')" 
              :subTitle="$t('global.text.nopermission')"
            >
              <template slot="extra">
                <el-button 
                  type="primary" 
                  size="medium"
                  @click="$router.push({ name: 'User List' })"
                >
                  {{ $t('global.button.back') }}
                </el-button>
              </template>
            </el-result>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.drink-settings-cell {
  white-space: pre-line;
  line-height: 1.35;
  word-break: break-word;
}

@media (min-width: 1800px) {
  .drink-settings-cell {
    font-size: 13px;
  }
  :deep(.el-table .cell) {
    line-height: 1.3;
  }
}
</style>